import Layout from '@/components/Layout';
import { CheckCircle2 } from 'lucide-react';

const BelgelerimizPage = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="pt-44 pb-16 bg-gradient-to-br from-slate-50 via-blue-50/30 to-white">
        <div className="eta-container">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-[#005CB2] font-semibold tracking-wider mb-3">BELGELERİMİZ</p>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Kurumsal Belgelerimiz
            </h1>
            <p className="text-lg text-slate-600">
              Yasal uygunluğumuzu ve kurumsal güvenilirliğimizi belgeleyen sertifikamız
            </p>
          </div>
        </div>
      </section>

      {/* İŞKUR Yetki Belgesi Section */}
      <section className="py-20 bg-white">
        <div className="eta-container">
          <div className="max-w-2xl mx-auto">
            <div className="bg-gradient-to-br from-slate-50 to-white rounded-3xl p-10 border border-slate-100 shadow-lg text-center">
              <div className="w-24 h-24 bg-[#005CB2] rounded-2xl flex items-center justify-center mx-auto mb-8">
                <CheckCircle2 className="w-12 h-12 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                İŞKUR Yetki Belgesi
              </h2>
              <p className="text-[#005CB2] font-semibold mb-6">Özel İstihdam Bürosu</p>
              <p className="text-slate-600 leading-relaxed mb-8">
                Türkiye İş Kurumu (İŞKUR) tarafından verilen Özel İstihdam Bürosu yetki belgemiz ile 
                yasal çerçevede insan kaynakları hizmetleri sunmaktayız. Bu belge, personel tedariki 
                ve istihdam aracılığı konusunda resmi yetkimizi kanıtlamaktadır.
              </p>
              <div className="bg-[#005CB2]/5 rounded-xl p-6">
                <p className="text-sm text-slate-600">
                  <strong className="text-slate-900">Yetki Kapsamı:</strong> Geçici iş ilişkisi kurma, 
                  iş ve işçi bulma, personel tedariki ve insan kaynakları danışmanlığı hizmetleri
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="eta-container">
          <div className="bg-[#005CB2] rounded-3xl p-12 text-center text-white">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Belgelerimiz Hakkında Detaylı Bilgi
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto mb-8">
              Yetki belgemiz ve yasal uygunluğumuz hakkında daha fazla bilgi almak için 
              bizimle iletişime geçebilirsiniz.
            </p>
            <a 
              href="/iletisim"
              className="inline-flex items-center gap-2 bg-white text-[#005CB2] px-8 py-3 rounded-full font-semibold hover:bg-slate-100 transition-colors"
            >
              İletişime Geçin
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BelgelerimizPage;
